import * as React from 'react';

import BaseIcon from 'shared/components/icons/BaseIcon';
import { IconSize, CommonIconProps } from 'shared/entities/components/Icon';

const ShouldPayIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      svgProps={{
        viewBox: '0 0 159 157'
      }}
      iconSize={IconSize.XXXL}
      {...props}
    >
      <path
        d="M74.0467 149.412C114.565 149.412 147.412 116.565 147.412 76.0462C147.412 35.5275 114.565 2.68066 74.0467 2.68066C33.528 2.68066 0.681152 35.5275 0.681152 76.0462C0.681152 116.565 33.528 149.412 74.0467 149.412Z"
        fill="#ECF6FD"
      />
      <g filter="url(#filter0_d_4787_873)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.7755 21.5313C69.0807 20.5764 71.5514 20.085 74.0466 20.085C76.5418 20.085 79.0125 20.5764 81.3178 21.5313C83.623 22.4861 85.7176 23.8857 87.4819 25.6501C89.2463 27.4144 90.6459 29.509 91.6007 31.8142C92.5556 34.1195 93.047 36.5902 93.047 39.0854V54.98C87.4866 51.6676 80.9888 49.7649 74.0465 49.7649C67.1043 49.7649 60.6065 51.6676 55.0462 54.9799V39.0854C55.0462 36.5902 55.5376 34.1195 56.4925 31.8142C57.4474 29.509 58.8469 27.4144 60.6113 25.6501C62.3756 23.8857 64.4702 22.4861 66.7755 21.5313ZM47.0462 61.3847V39.0854C47.0462 35.5396 47.7446 32.0286 49.1015 28.7528C50.4584 25.4769 52.4472 22.5004 54.9544 19.9932C57.4616 17.486 60.4382 15.4971 63.714 14.1402C66.9898 12.7833 70.5009 12.085 74.0466 12.085C77.5924 12.085 81.1034 12.7833 84.3792 14.1402C87.6551 15.4971 90.6316 17.486 93.1388 19.9932C95.646 22.5004 97.6349 25.4769 98.9918 28.7528C100.349 32.0286 101.047 35.5396 101.047 39.0854V61.3849C107.356 68.0476 111.226 77.044 111.226 86.9442C111.226 107.478 94.5801 124.124 74.0465 124.124C53.5129 124.124 36.8672 107.478 36.8672 86.9442C36.8672 77.0439 40.7368 68.0474 47.0462 61.3847Z"
          fill="white"
        />
      </g>
      <path
        d="M82.4689 83.359C82.4693 81.9193 82.1009 80.5036 81.3987 79.2468C80.6964 77.99 79.6839 76.934 78.4577 76.1798C77.2315 75.4255 75.8324 74.9979 74.394 74.938C72.9556 74.878 71.5258 75.1876 70.241 75.8372C68.9563 76.4869 67.8594 77.4549 67.055 78.6488C66.2506 79.8428 65.7656 81.223 65.6462 82.6577C65.5268 84.0924 65.777 85.5338 66.3729 86.8443C66.9689 88.1549 67.8907 89.2908 69.0504 90.1439C69.669 90.5943 70.1278 91.2302 70.3601 91.9593C70.5925 92.6884 70.5862 93.4725 70.3422 94.1978V94.2172C70.1582 94.7558 70.1055 95.3305 70.1883 95.8935C70.2711 96.4566 70.487 96.9918 70.8182 97.4546C71.1494 97.9175 71.5863 98.2946 72.0925 98.5546C72.5987 98.8147 73.1597 98.9502 73.7288 98.9499H74.3728C74.9416 98.9496 75.5021 98.8137 76.0078 98.5533C76.5136 98.293 76.9499 97.9158 77.2807 97.453C77.6114 96.9903 77.827 96.4553 77.9096 95.8926C77.9922 95.3298 77.9394 94.7554 77.7555 94.2172V94.1978C77.5126 93.4686 77.5084 92.681 77.7435 91.9492C77.9786 91.2175 78.4407 90.5797 79.0629 90.1284C80.1216 89.3461 80.9815 88.3258 81.5732 87.1499C82.1648 85.974 82.4717 84.6754 82.4689 83.359Z"
        fill="#7F909F"
      />
      <path
        d="M74.0466 110.98C74.9614 110.98 75.7031 110.238 75.7031 109.323C75.7031 108.409 74.9614 107.667 74.0466 107.667C73.1318 107.667 72.3901 108.409 72.3901 109.323C72.3901 110.238 73.1318 110.98 74.0466 110.98Z"
        fill="#98CDF1"
      />
      <g filter="url(#filter1_d_4787_873)">
        <path
          d="M131.984 91.8076H90.4638C84.4777 91.8076 79.625 96.6603 79.625 102.646V125.43C79.625 131.416 84.4777 136.268 90.4638 136.268H131.984C137.97 136.268 142.823 131.416 142.823 125.43V102.646C142.823 96.6603 137.97 91.8076 131.984 91.8076Z"
          fill="#ABD6F4"
        />
      </g>
      <path
        d="M94.8943 102.643H89.5448C88.0557 102.643 86.8486 103.85 86.8486 105.339V108.458C86.8486 109.947 88.0557 111.154 89.5448 111.154H94.8943C96.3834 111.154 97.5905 109.947 97.5905 108.458V105.339C97.5905 103.85 96.3834 102.643 94.8943 102.643Z"
        fill="white"
      />
      <path
        d="M96.2676 122.792H88.1715C87.4409 122.792 86.8486 123.384 86.8486 124.115C86.8486 124.845 87.4409 125.438 88.1715 125.438H96.2676C96.9982 125.438 97.5905 124.845 97.5905 124.115C97.5905 123.384 96.9982 122.792 96.2676 122.792Z"
        fill="#4EA9E7"
      />
      <path
        d="M109.081 122.792H100.984C100.254 122.792 99.6616 123.384 99.6616 124.115C99.6616 124.845 100.254 125.438 100.984 125.438H109.081C109.811 125.438 110.403 124.845 110.403 124.115C110.403 123.384 109.811 122.792 109.081 122.792Z"
        fill="#4EA9E7"
      />
      <path
        d="M121.89 122.792H113.794C113.063 122.792 112.471 123.384 112.471 124.115C112.471 124.845 113.063 125.438 113.794 125.438H121.89C122.621 125.438 123.213 124.845 123.213 124.115C123.213 123.384 122.621 122.792 121.89 122.792Z"
        fill="#4EA9E7"
      />
      <path
        d="M134.7 122.792H126.604C125.873 122.792 125.281 123.384 125.281 124.115C125.281 124.845 125.873 125.438 126.604 125.438H134.7C135.43 125.438 136.023 124.845 136.023 124.115C136.023 123.384 135.43 122.792 134.7 122.792Z"
        fill="#4EA9E7"
      />
      <path
        d="M109.461 49.1394C108.118 50.1925 107.101 51.6054 106.529 53.2137C105.957 54.8221 105.853 56.5598 106.23 58.2247C106.441 59.0958 106.428 60.0062 106.191 60.8707C105.954 61.7351 105.502 62.5253 104.876 63.167L98.2809 69.7618C97.7962 70.2454 97.4117 70.8198 97.1494 71.4522C96.887 72.0846 96.752 72.7625 96.752 73.4472C96.752 74.1318 96.887 74.8097 97.1494 75.4421C97.4117 76.0745 97.7962 76.6489 98.2809 77.1325C98.4687 77.3209 98.6918 77.4703 98.9374 77.5723C99.183 77.6743 99.4464 77.7268 99.7124 77.7268C99.9783 77.7268 100.242 77.6743 100.487 77.5723C100.733 77.4703 100.956 77.3209 101.144 77.1325L101.532 76.7446C101.72 76.5568 101.87 76.3337 101.972 76.0881C102.074 75.8424 102.126 75.5791 102.126 75.3131C102.126 75.0471 102.074 74.7838 101.972 74.5381C101.87 74.2925 101.72 74.0694 101.532 73.8816C101.473 73.8232 101.426 73.7537 101.394 73.6771C101.362 73.6006 101.346 73.5184 101.346 73.4355C101.346 73.3526 101.362 73.2704 101.394 73.1939C101.426 73.1173 101.473 73.0478 101.532 72.9894L108.127 66.3946C108.752 65.7704 109.526 65.3166 110.376 65.0762C111.227 64.8358 112.124 64.8169 112.983 65.0213C114.468 65.3656 116.016 65.3282 117.482 64.9128C118.948 64.4974 120.285 63.7174 121.368 62.6455C122.452 61.5737 123.246 60.2449 123.677 58.7832C124.108 57.3215 124.162 55.7745 123.833 54.2864C123.505 52.7983 122.805 51.4176 121.798 50.2731C120.792 49.1287 119.512 48.2577 118.079 47.7415C116.645 47.2253 115.104 47.0806 113.599 47.321C112.094 47.5613 110.674 48.1789 109.473 49.1161L109.461 49.1394ZM118.736 58.7252C118.205 59.5206 117.433 60.1241 116.532 60.4465C115.632 60.769 114.652 60.7933 113.736 60.5158C112.821 60.2383 112.019 59.6739 111.45 58.9057C110.88 58.1376 110.572 57.2066 110.572 56.2502C110.572 55.2938 110.88 54.3627 111.45 53.5946C112.019 52.8265 112.821 52.262 113.736 51.9845C114.652 51.7071 115.632 51.7314 116.532 52.0538C117.433 52.3763 118.205 52.9798 118.736 53.7752C119.231 54.5058 119.496 55.3679 119.496 56.2502C119.496 57.1325 119.231 57.9946 118.736 58.7252Z"
        fill="#3BA0E5"
      />
      <defs>
        <filter
          id="filter0_d_4787_873"
          x="20.8672"
          y="0.0849609"
          width="106.358"
          height="144.038"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.662745 0 0 0 0 0.709804 0 0 0 0 0.752941 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4787_873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4787_873"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4787_873"
          x="63.625"
          y="79.8076"
          width="95.1978"
          height="76.4609"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.662745 0 0 0 0 0.709804 0 0 0 0 0.752941 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4787_873"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4787_873"
            result="shape"
          />
        </filter>
      </defs>
    </BaseIcon>
  );
};

export default ShouldPayIcon;
